import { PageUniverseDto } from "src/api/search";
import { GridPublic as GridSummaryDtoV3, PageUniverseDto as PageUniverseDtoV3, UniversePublic as UniverseDtoV3 } from "src/api/search_v3";

export interface CustomGridSummaryDto extends Omit<GridSummaryDtoV3, 'id' | 'subGrids'> {
    id?: number;
    subGrids?: CustomGridSummaryDto[];
}

export interface CustomUniverseDto extends Omit <UniverseDtoV3, 'grids'> {
    grids?: Array<CustomGridSummaryDto>;
}

export interface CustomPageUniverseDto extends Omit <PageUniverseDtoV3, 'content'> {
    content?: Array<CustomUniverseDto>;
}


export function modifyGridsWithFilterId<T extends { content?: Array<{ grids?: Array<{ externalGridId?: number; subGrids?: Array<any>; [key: string]: any }>; [key: string]: any }> }>(
  data: T
): T {
  if (!data?.content || !Array.isArray(data.content)) {
    return data;
  }

  const processGrid = (grid: any): any => {
    const processedGrid = {
      ...grid,
      ...(grid.externalGridId !== undefined && { id: grid.externalGridId })
    };

    if (processedGrid.subGrids && Array.isArray(processedGrid.subGrids)) {
      processedGrid.subGrids = processedGrid.subGrids.map(processGrid);
    }

    return processedGrid;
  };

  const modifiedContent = data.content.map((universe) => {
    if (!universe.grids || !Array.isArray(universe.grids)) {
      return universe;
    }

    const modifiedGrids = universe.grids.map(processGrid);

    return {
      ...universe,
      grids: modifiedGrids
    };
  });

  return {
    ...data,
    content: modifiedContent
  };
}

export function modifyUniverseGrids(data: any) {
  return modifyGridsWithFilterId(data);
}

export const normalizeUniverseV1 = (data: PageUniverseDto): CustomPageUniverseDto => {
  return {
    totalElements: data.totalElements,
    totalPages: data.totalPages,
    pageable: data.pageable ? {
      pageSize: data.pageable.pageSize,
      pageNumber: data.pageable.pageNumber,
      offset: data.pageable.offset,
      sort: data.pageable.sort ? {
        empty: data.pageable.sort.empty,
        sorted: data.pageable.sort.sorted,
        unsorted: data.pageable.sort.unsorted,
      } : undefined,
      paged: data.pageable.paged,
      unpaged: data.pageable.unpaged,
    } : undefined,
    first: data.first,
    last: data.last,
    size: data.size,
    content: data.content?.map(universe => ({
      id: universe.id,
      name: universe.name,
      title: universe.title,
      description: universe.description,
      categories: universe.categories,
      rank: universe.rank,
      isDefault: universe.default,
      grids: universe.grids?.map(grid => ({
        id: grid.id,
        name: grid.name,
        title: grid.title,
        description: grid.description,
        rank: grid.rank,
        defaultInUniverse: grid.default,
        subGrids: [],
        parentGrids: [],
        gridFilterId: undefined,
        externalGridId: undefined,
        isPublished: true,
        visible: true,
      })),
    })),
    number: data.number,
    sort: data.sort ? {
      empty: data.sort.empty,
      sorted: data.sort.sorted,
      unsorted: data.sort.unsorted,
    } : undefined,
    numberOfElements: data.numberOfElements,
    empty: data.empty,
  };
};

export const normalizeUniverseV3 = (data: PageUniverseDtoV3): CustomPageUniverseDto => {
  return modifyUniverseGrids(data) as CustomPageUniverseDto;
};